module.exports = __webpack_public_path__ + "img/OurServiceFixed_pic1.e216d413.png";